/**
 * The exhaustiveness check every discriminated-union switch in the portal ends
 * with: adding a variant without handling it becomes a compile error at each
 * `default`, and an impossible value at runtime throws with the value in hand
 * rather than rendering nothing.
 *
 * `subject` names what was unhandled — "failure kind", "resource status" — so
 * the thrown message says which union drifted, not merely that one did.
 */
export const assertNever = (value: never, subject: string): never => {
  throw new Error(`Unhandled ${subject}: ${JSON.stringify(value)}`)
}
